import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SidduSuhasResumePage from './pages/SidduSuhasResumePage';
import NotFoundPage from './pages/NotFoundPage';
import Layout from './components/Layout';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout className="home-page"><HomePage /></Layout>} />
        <Route path="/siddu-suhas" element={<Layout className="resume-page"><SidduSuhasResumePage /></Layout>} />
        <Route path="*" element={<Layout className="home-page"><NotFoundPage /></Layout>} />
      </Routes>
    </Router>
  );
}

export default App;
